<template>
    <!-- This component is for regular banners, e.g. discount/page specific -->
    <div>
        <template v-if="banners != null && banners[0]?.link">
            <a :href="banners[0].link" class="item" :title="banners[0].name">
                <div class="d-none d-sm-block p-3" :style="desktopBackgroundStyle">
                    <div class="banner-content" :class="banners[0].dark_desktop_banner == 1 ? 'text-light' : 'text-dark'" v-if="banners[0]" v-html="banners[0].content "></div>
                </div>
                <div class="d-block d-sm-none p-3" :style="mobileBackgroundStyle">
                    <div class="banner-content" :class="banners[0].dark_mobile_banner == 1 ? 'text-light' : 'text-dark'" v-if="banners[0]" v-html="banners[0].content "></div>
                </div>
            </a>
        </template>
        <template v-else>
            <div class="d-none d-sm-block p-3" :style="desktopBackgroundStyle">
                <div class="banner-content" :class="banners[0].dark_desktop_banner == 1 ? 'text-light' : 'text-dark'" v-if="banners != null && banners[0]" v-html="banners[0].content "></div>
            </div>
            <div class="d-block d-sm-none p-3" :style="mobileBackgroundStyle">
                <div class="banner-content" :class="banners[0].dark_mobile_banner == 1 ? 'text-light' : 'text-dark'" v-if="banners != null && banners[0]" v-html="banners[0].content "></div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['banners', 'page'],
        data() {
            return {
            }
        },
        mounted() {

        },
        methods: {

        },
        computed: {
            desktopBackgroundStyle() {
                var bannerUrl = '';
                
                //TODO refactor this to be dynamic, using the passed in page variable for the image url
                if(this.page == 'select_tyres') {
                    bannerUrl = (this.banners != null && typeof(this.banners[0]) != 'undefined') ? this.banners[0].select_tyres_image_url : null;
                }
                else if(this.page == 'brand') {
                    bannerUrl = (this.banners != null && typeof(this.banners[0]) != 'undefined') ? this.banners[0].brand_image_url : null;
                }
                else if(this.page == 'discount') {
                    bannerUrl = (this.banners != null && typeof(this.banners[0]) != 'undefined') ? this.banners[0].promo_image_url : null;
                }

                var style = 'background: url(' + (bannerUrl) + ') no-repeat; background-size: cover; background-position: center center;';
                
                return style;
            },
            mobileBackgroundStyle() {
                var bannerUrl = '';

                if(this.page == 'select_tyres') {
                    bannerUrl = (this.banners != null && typeof(this.banners[0]) != 'undefined') ? this.banners[0].select_tyres_mobile_image_url : null;
                }
                else if(this.page == 'brand') {
                    bannerUrl = (this.banners != null && typeof(this.banners[0]) != 'undefined') ? this.banners[0].brand_mobile_image_url : null;
                }
                else if(this.page == 'discount') {
                    bannerUrl = (this.banners != null && typeof(this.banners[0]) != 'undefined') ? this.banners[0].promo_mobile_image_url : null;
                }

                var style = 'background: url(' + (bannerUrl) + ') no-repeat; background-size: cover; background-position: center center;';
                
                return style;
            }
        }
    }
</script>

<style lang="scss" scoped>
    a {
        text-decoration: none;
    }
</style>